import React from 'react'
import { css } from '@emotion/react'
import { rgba } from 'polished'
import { colors, timings } from 'shared-ui'
import { FormattedMessage } from 'react-intl'
import ModalHeader from '../modals/ModalHeader'

const style = {
    overlay: (padOverlay) => css`
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10000;
        width: 100lvw;
        background-color: ${rgba(colors.black, 0.45)};
        height: calc(var(--vh, 1vh) * 100);
        display: flex;
        overflow-y: scroll;
        flex-direction: column;
        align-items: center;
        padding: ${padOverlay ? '2em' : 0};
        &::-webkit-scrollbar {
            display: none
        };
        -ms-overflow-style: none;
        scrollbar-width: none;
    `,
    modal: css`
        margin: auto;
        position: relative;
        overflow-y: auto;
        border-radius: 0.25em;
        background-color: #232628;
        color: ${colors.white};
        box-shadow: 0 0.5em 5em 0.5em black;
        width: 32em;
        max-width: 100%;

        &::-webkit-scrollbar {
            display: none;
        }

        @media(max-width: 640px) {
            padding: 1em;
            padding-top: 2.5em;
        }

        button.btn {
            border: 2px solid #97F6CB;
            border-radius: .5em;
            background: transparent;
            color: white;
            text-transform: uppercase;
            font-weight: bold;
            padding: .5em 1.5em;
            float: right;
            margin: 1.5em 0em;
            cursor: pointer;
            transition: background ${timings.smooth};

            &:hover {
                background: ${colors.eventDark};
            }
        }

    `,
    closeBtn: css`
        position: absolute;
        top: 1em;
        right: 0.7em;
        border-radius: 0.5em;
        text-transform: uppercase;
        background-color: ${colors.black};
        color: ${colors.white};
        border: 2px solid #3A4147;
        height: 2em;
        cursor: pointer;
        outline: none;
        opacity: 0.5;
        transition: all 200ms ease;
        &:hover {
            opacity: 1;
        }
    `,
    content: css`
        padding: 3em;
`,
}

export default function Modal({
    onClickClose,
    children,
    header = null,
    padOverlay = true,
    padContent = true,
    hideCloseButon = false,
    ...props
}) {
    return (
        // TO DO: use dialog element
        <div
            className='closingOverlay'
            css={style.overlay(padOverlay)}
            onClick={(e) => {
                const targetClasses = [...e.target.classList] // Capture classes first
                e.stopPropagation()
                if (targetClasses.includes('closingOverlay')) onClickClose()
            }}
        >
            <div
                css={style.modal}
                {...props}
            >
                {header &&
                    <ModalHeader header={header} />
                }
                <div css={ padContent ? style.content : css``}>
                    {children}
                </div>
                {!hideCloseButon &&
                    <button css={style.closeBtn} type='button' onClick={onClickClose}>
                        <FormattedMessage id='closeWindow' />
                    </button>
                }
            </div>
        </div>
    )
}